/**
 * @generated SignedSource<<8fd1625193fcf979835541f2b636df02>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type analytics_setUserInfo$data = {
  readonly email: string | null | undefined;
  readonly name: string | null | undefined;
  readonly rawId: number | null | undefined;
  readonly realUser: {
    readonly email: string | null | undefined;
    readonly name: string | null | undefined;
    readonly rawId: number | null | undefined;
    readonly unconfirmedEmail: string | null | undefined;
  } | null | undefined;
  readonly unconfirmedEmail: string | null | undefined;
  readonly " $fragmentType": "analytics_setUserInfo";
};
export type analytics_setUserInfo$key = {
  readonly " $data"?: analytics_setUserInfo$data;
  readonly " $fragmentSpreads": FragmentRefs<"analytics_setUserInfo">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "analytics_setUserInfo"
};

(node as any).hash = "cfaa366d93ba81e2ef0f1015017e0260";

export default node;
